export default {"src":"/_next/static/media/spotify.3f10aa09.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};